import React from "react";
import { connect } from "react-redux";
import { Col, Container, Modal, Row } from "react-bootstrap";
import { userActions } from "../../_actions";
import { busquedaActions } from "../../_actions/busqueda.actions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavBarLateral } from "./NavBarLateral";
import MenuFiltro from "../includes/MenuFiltro";
import { FormCambiarPassword } from "../perfil/FormCambiarPassword";
import authService from "../../_services/cart/authService";
import { Link } from "react-router-dom";

import { Formik, Form, Field } from "formik";
import { ERR, ErrorMessage, LoadingBoton } from "../../_helpers";
import * as Yup from "yup";
import { userService } from "../../_services";
import alertService from "../../_services/cart/alert.service";

const tableRef3 = React.createRef();
const bagRef = React.createRef();
const _ = require("lodash");

class MpModalComision extends React.Component {
  constructor(props) {
    super(props);
  }

  state = {
    loading: false,
    show: false,
  };

  componentDidMount() {}

  render() {
    const user = authService.getLoggedUser();
    const { show, handleClose } = this.props;

    console.log(user);
    let inic = {
      mercadoPagoWebhookKey: user?.detail?.mercadoPagoWebhookKey ?? "",
    };

    const validationSchema = Yup.object().shape({
      mercadoPagoWebhookKey: Yup.string()
        .min(12, "La clave secreta debe tener al menos 15 caracteres")
        .max(100, "Demasiado largo"),
    });

    return (
      <>
        <div className="dashboard">
          <NavBarLateral handleClose={this.handleClose} />
          <div className="dashboard__content">
            <div className="dashboard__content-header">
              <div className="dashboard__content-title">
                <h2>
                  ¿Que comisiones tienen mis pagos por Mercado pago y como configurarlas?
                </h2>
              </div>
            </div>

            <div className="dashboard__content-main">
              <div className="mp__steps">                
                <h3>Paso 1</h3>
                <div className="dashboard__content-prod-mpSteps">
                  <p>
                    Ingresar en tu cuenta de mercado pago haciendo click aquí en el siguiente link:
                    &nbsp;
                    <a href="https://www.mercadopago.com.ar/" target="_blank">
                       Mercado pago
                    </a>
                  </p>
                </div>

                <h3>Paso 2</h3>
                <div className="dashboard__content-prod-mpSteps">
                  Una vez iniciada la sesión en mercado pago vamos al menu de la izquierda:
                  <ol>
                    <li>Tu Negocio</li>
                    <li>Costos y cuotas</li>                    
                    <li><img src={process.env.PUBLIC_URL +"/images/MO-Comisiones-1.png"}></img></li>   
                  </ol>

                 
                </div>

                <h3>Paso 3</h3>
                <div className="dashboard__content-prod-mpSteps">
                  Ingresar en "Configurar costos por cobro"
                  <ol>
                    <li>Seleccionar Modo de acreditacion de los pagos</li>
                    <li>Guardar</li>                    
                    <li><img src={process.env.PUBLIC_URL +"/images/MO-Comisiones-2.png"}></img></li>   
                    <li>Los proximos pagos que recibas tendran la comisión nueva seleccionada</li>       
                  </ol>

                 
                </div>

              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

function mapState(state) {
  return {};
}

const actionCreators = {};

const connectedMpModalComision = connect(mapState, actionCreators)(MpModalComision);
export { connectedMpModalComision as MpModalComision };
